<div class="requester-card" [class.draft]="isCreateMode">
  <em class="requester-icon" [ngClass]="isDepartment ? 'icon-requester-department' : 'icon-requester-store'"></em>
  <div class="requester-caption">Requester</div>
  <div class="requester-title">{{ requesterTypeLabel }}</div>
  <div class="requester-divider"></div>
  <div class="requester-caption">Requested By</div>
  <div class="requester-name">{{ displayRequesterName((userInfoResult$ | async)?.displayName) }}</div>
  <div class="requester-date" *ngIf="requestedDate">
    {{ requestedDate | amFromUtc | amLocal | dateDisplay: dateTimeDisplay }}
  </div>
</div>
